import { personalInfo } from "../data/mock";
import SeoHead from "../components/SeoHead";

const Terms = () => {
  return (
    <div>
      <SeoHead
        title="Terms & Conditions | Abhilash Puljal"
        description="Terms of use governing access to and use of Abhilash Puljal's professional portfolio website."
        path="/terms"
      />
      <section className="py-20 bg-[#FAF8F4]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <p className="text-xs tracking-[0.3em] uppercase text-[#B8945A] font-sans mb-4">Legal</p>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1C2B3A] mb-4">Terms &amp; Conditions</h1>
          <div className="w-20 h-[2px] bg-[#B8945A]"></div>
          <p className="font-sans text-sm text-[#7A7A7A] mt-6">Last updated: July 2025</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 font-sans text-[#4A4A4A] leading-[1.85] space-y-10">
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">1. Acceptance of Terms</h2>
            <p>By accessing and using this website (abhilash.com), you accept and agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use this website.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">2. Intellectual Property</h2>
            <p>All content on this website, including but not limited to text, graphics, logos, images, publications, and design elements, is the intellectual property of Abhilash Puljal unless otherwise stated. Unauthorized reproduction, distribution, or use of any content is strictly prohibited.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">3. Use of Website</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>This website is for informational and professional purposes only.</li>
              <li>You agree not to use this website for any unlawful purpose.</li>
              <li>You agree not to attempt unauthorized access to any part of the website.</li>
              <li>Content downloaded from this website is for personal, non-commercial use only.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">4. Profile Downloads</h2>
            <p>Professional profiles and documents available for download are provided for informational purposes. By downloading any document, you agree to use it solely for evaluating professional collaboration opportunities and not for any commercial redistribution.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">5. Disclaimer</h2>
            <p>The information on this website is provided "as is" without any warranties, express or implied. While we strive to keep the information accurate and up to date, we make no representations about the completeness, reliability, or accuracy of the content.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">6. Limitation of Liability</h2>
            <p>Abhilash Puljal shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of or inability to use this website.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">7. External Links</h2>
            <p>This website may contain links to external websites. We have no control over the content or practices of these sites and accept no responsibility for them.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">8. Governing Law</h2>
            <p>These Terms and Conditions are governed by and construed in accordance with the laws of India. Any disputes arising from the use of this website shall be subject to the exclusive jurisdiction of the courts in New Delhi, India.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">9. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this page with an updated revision date. Continued use of the website constitutes acceptance of the modified terms.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">10. Contact</h2>
            <p>For questions about these Terms and Conditions, please contact:</p>
            <p className="mt-3"><strong>Abhilash Puljal</strong><br />Email: {personalInfo.contact.email}<br />Address: {personalInfo.contact.address}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;